import { call, put, select, takeLatest } from 'redux-saga/effects'

import { ErrorCodes } from '@enums'
import { ResponseError } from '@lib/error'
import { IHateoasLink } from '@store'
import { selectAuthToken } from '@store/auth'
import {
  lookupYouTubeChannel,
  lookupYouTubeChannelError,
  lookupYouTubeChannelSuccess,
  YouTubeChannelLookupActionTypes,
} from '@store/drafts'
import { selectLink } from '@store/rootResource'
import { networkRequest } from '@utils'

const isNotFound = (error: unknown) =>
  error instanceof ResponseError &&
  error.status === 422 &&
  Array.isArray(error.messages) &&
  error.messages[0]?.error_code === ErrorCodes.YOUTUBE_CHANNEL_LOOKUP_NOT_FOUND

export function* handleLookupYouTubeChannel(action: ReturnType<typeof lookupYouTubeChannel>) {
  try {
    const authToken: string = yield select(selectAuthToken)
    const link: IHateoasLink | undefined = yield select(selectLink, 'youtube_channel_lookup')
    // Fail open: link absent (backend not deployed / stale persisted root) accepts the handle.
    if (link) {
      const handle = encodeURIComponent(action.payload.handle)
      yield call(networkRequest, link.method, `${link.href}?handle=${handle}`, undefined, authToken)
    }
    yield put(lookupYouTubeChannelSuccess(true))
  } catch (error) {
    yield put(
      isNotFound(error) ? lookupYouTubeChannelSuccess(false) : lookupYouTubeChannelError(error),
    )
  }
}

export function* watchLookupYouTubeChannelRequest() {
  yield takeLatest(YouTubeChannelLookupActionTypes.LOOKUP_REQUEST, handleLookupYouTubeChannel)
}
